import React, { Component } from 'react';

class Footer extends Component {
    render() {
        return (
            <div className="Header" style={{ "backgroundColor": "#e3f2fd",textAlign:'right' }}>
                <hr></hr>
                تمامی حقوق مادی و معنوی این سایت متعلق به  است و استفاده از مطالب با ذکر منبع بلامانع است.
                <br />
                <br />
                <hr></hr>
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/layout/Footer.js